import { Injectable } from '@angular/core';
import { ReplaySubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class TabService {
  private isReadonlySubject = new ReplaySubject<boolean>(1);
  isReadonly$ = this.isReadonlySubject.asObservable();
  isReadonly = false;
  constructor() { }

  enable(): void {
    this.isReadonlySubject.next(false);
    this.isReadonly = false;
  }
  disable(): void {
    this.isReadonlySubject.next(true);
    this.isReadonly = true;
  }

}
